import { Chip } from "@mui/material";

export const statusRender = (params) => {
  switch (params.data.acStatusName) {
    case "Neaktivan":
      return <Chip label="Neaktivan" color="error" variant="outlined" />;
    case "Aktivan":
      return <Chip label="Aktivan" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const statusRenderStatus = (params) => {
  switch (params.data.status) {
    case "Neaktivan":
      return <Chip label="Neaktivan" color="error" variant="outlined" />;
    case "Aktivan":
      return <Chip label="Aktivan" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const primaryRender = (params) => {
  switch (params.data.isPrimary) {
    case false:
      return <Chip label="Ne" color="error" variant="outlined" />;
    case true:
      return <Chip label="Da" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const formatSizeLabel = (size) => {
  if (!size) return "";

  const [unit, value] = size.split("_");

  if (unit === "KG") return `${value}kg`;
  if (unit === "GR") return `${value}gr`;

  return size;
};

const coffeeTypeMap = {
  WHOLE_BEANS: "Whole beans",
  ESPRESSO_MACHINE: "Espresso Machine",
  MOKA_POT: "Moka Pot",
  AEROPRESS: "Aeropress",
  V60: "V60",
  FRENCH_PRESS: "French Press",
  CHEMEX: "Chemex",
  AUTOMATIC_FILTER_MACHINE: "Automatic Filter Machine",
  TURKISH: "Turkish",
};

export const formatCoffeeType = (type) => {
  return coffeeTypeMap[type] || type;
};
